import styled from "styled-components";

export const HomePageContainer = styled.main`
  width: 100%;
  height: calc(100vh - 155px);
  border-radius: 5px;
  color: #fff;
  font-family: Roboto;
  font-size: 48px;
  position: relative;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.19;
  letter-spacing: normal;
  text-align: right;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 20px; 
`;

export const WelcomeText = styled.div`
  position: absolute;
  bottom: 45%;
  right: 20%;
  color: #000;
  font-size: 48px;
`;